import CheckMarkIcon from "@assets/icons/checkMarkIcon";
import CollapseArrowIcon from "@assets/icons/collapseArrowIcon";
import { PolicyEnum } from "@config/policyEnum";
import { useHasPolicy } from "@config/useHasPolicy";
import {
  Box,
  Card,
  FormControl,
  MenuItem,
  Select,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router";

interface UserContactInformationProps {
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  errors:any;
  userData:any;
  updateUserInfo:boolean;
}

const UserContactInformation: React.FC<UserContactInformationProps> = ({
  handleChange,
  errors,
  userData,
  updateUserInfo
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [showContactInformation, setShowContactInformation] = useState(true);
  const {countryCodeList} = useSelector((state: any) => state.addUser);
  const {id} = useParams();
  const handleCollapse = () => {
    setShowContactInformation(!showContactInformation);
  };
   const isDisabled = id ? !updateUserInfo : false
   const showPrimaryEmailId = useHasPolicy(PolicyEnum.VIEW_USER_EMAIL);
   const showCountryCode = useHasPolicy(PolicyEnum.VIEW_USER_COUNTRY_CODE);
   const showPrimaryContactNumber = useHasPolicy(PolicyEnum.VIEW_USER_CONTACT);
   const editPrimaryEmailId = useHasPolicy(PolicyEnum.EDIT_USER_EMAIL);
   const editCountryCode = useHasPolicy(PolicyEnum.EDIT_USER_COUNTRY_CODE);
   const editPrimaryContactNumber = useHasPolicy(PolicyEnum.EDIT_USER_CONTACT);

  return (
    <>
    {(showPrimaryEmailId || showCountryCode || showPrimaryContactNumber) &&
    <Card className="mt-4 md:mt-2 md:!shadow-none">
      <Box className=" hidden md:flex md:items-center bg-[#F2F2F2]" sx={{ ml: '5px' }}>
        <Typography
          onClick={() => setShowContactInformation(true)}
          sx={{
            padding: "0.5rem 0.5rem 0.5rem 1rem",
            fontWeight: 500,
            fontSize:"15px"
          }}
        >
          Contact Information
        </Typography>
      </Box>
      <Box
        className="flex justify-between items-center border-b-2 md:hidden"
      >
        <Box className="flex items-center">
          <Typography
            sx={{
              padding: "0.5rem 0.5rem 0.5rem 1rem",
              backgroundColor: { xs: "#fff", sm: "#F2F2F2" },
              fontWeight: 400,
              fontSize:"16px"
            }}
          >
            Contact Information
          </Typography>
          <CheckMarkIcon />
        </Box>
        <Typography className="pr-3" onClick={handleCollapse}>
          <CollapseArrowIcon />
        </Typography>
      </Box>
      {(showContactInformation || !isMobile) && (
        <Box className="grid grid-cols-1  md:grid-cols-2 lg:grid-cols-4 gap-5 p-4 ">
          {showPrimaryEmailId &&
          <Box className="flex flex-col ">
            <Typography variant="body1" className="user-form-lbl">
              Primary Email ID <span style={{ color: "red" }}>*</span>
            </Typography>
            <TextField
              required
              fullWidth
              name="emailID"
              placeholder="Enter Email ID"
              size="small"
              onChange={handleChange}
              value={userData.emailID}
              error={!!errors.emailID}
              helperText={errors.emailID}
              disabled={isDisabled || (id ? !editPrimaryEmailId: false)}
            />
          </Box>}
          {showCountryCode &&
          <Box className="flex flex-col">
            <Typography variant="body1" className="user-form-lbl">
              Country Code <span style={{ color: "red" }}>*</span>
            </Typography>
            <FormControl required fullWidth size="small">
              <Select
                defaultValue=""
                displayEmpty
                disabled={isDisabled || (id ? !editCountryCode: false)}
                name="countryCode"
                aria-label="countryCode"
                onChange={handleChange}
                renderValue={(selected) => {
                  if (!selected) {
                      if(userData.countryCode){
                        return userData.countryCode
                      }else{
                        return (
                          <Typography sx={{ color: "#0000005D" }}>
                            Select Country Code
                          </Typography>
                        );
                      }
                  }
                  return selected;
                }}
              >
                {countryCodeList.map((item:any)=>(
                   <MenuItem key={item.countryCode} value={item.countryCode}>{item.countryCode}</MenuItem>
                ))}
              </Select>
                <Typography variant="caption" color="error">{errors.countryCode}</Typography>
            </FormControl>
          </Box>}
          {showPrimaryContactNumber &&
          <Box className="flex flex-col">
            <Typography variant="body1" className="user-form-lbl">
              Primary Contact Number<span style={{ color: "red" }}>*</span>
            </Typography>
            <TextField
              required
              fullWidth
              name="contactNumber"
              placeholder="000 000 0000"
              size="small"
              value={userData.contactNumber}
              onKeyDown={(e) => {
                if (!/\d/.test(e.key) && e.key !== "Backspace" && e.key !== "Tab" && e.key !== "ArrowLeft" && e.key !== "ArrowRight") {
                  e.preventDefault();
                }
              }}
              onChange={handleChange}
              error={!!errors.contactNumber}
              helperText={errors.contactNumber}
              disabled={isDisabled || (id ? !editPrimaryContactNumber: false)}
            />
          </Box>}
        </Box>
      )}
    </Card>}
    </>
  );
};

export default UserContactInformation;
